<template>
  <a-col :span="24">
    <a-form-item
      name="competenciesSubject"
      label="Целевые компетенции. Предметные области"
      class="competencies_form_item"
      :help="errors.getError('competenciesSubject')"
      :validate-status="errors.getStatus('competenciesSubject')"
    >
      <c-input-competencies
        :type="COMPETENCE_TYPE_SUBJECT"
        :items="competenciesSubject"
        :disabled="disabled"
        @update="updateCompetenciesSubject"
      />
    </a-form-item>
    <a-form-item
      name="competenciesTechnology"
      label="Целевые компетенции. Технологии"
      class="competencies_form_item"
    >
      <c-input-competencies
        :type="COMPETENCE_TYPE_TECHNOLOGY"
        :items="competenciesTechnology"
        :disabled="disabled"
        @update="updateCompetenciesTechnology"
      />
    </a-form-item>
    <a-form-item
      name="competenciesSkill"
      label="Целевые компетенции. Навыки"
      class="competencies_form_item"
    >
      <c-input-competencies
        :type="COMPETENCE_TYPE_SKILL"
        :items="competenciesSkill"
        :disabled="disabled"
        @update="updateCompetenciesSkill"
      />
    </a-form-item>
  </a-col>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import { useRoute } from 'vue-router';
  import ErrorsHandler from '@/components/form/errors-handler';
  import CInputCompetencies from '@/components/UI/CInputCompetencies.vue';
  import {
    COMPETENCE_TYPE_SKILL,
    COMPETENCE_TYPE_SUBJECT,
    COMPETENCE_TYPE_TECHNOLOGY,
  } from '@/api/models/CompetenceType';

  const api = useApi();
  const route = useRoute();
  const emit = defineEmits(['saved']);

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const competenciesSubject = ref([]);
  const competenciesTechnology = ref([]);
  const competenciesSkill = ref([]);

  const errors = new ErrorsHandler({
    competenciesSubject: '',
    competenciesTechnology: '',
    competenciesSkill: '',
  });

  onMounted(async () => {
    await getCompetencies();
  });

  const getCompetencies = async () => {
    try {
      const response = await api.competence.index(
        new URLSearchParams({
          briefcaseId: route.params.id,
        })
      );
      competenciesSubject.value = response.competencies.items.filter(
        (el) => el.type === COMPETENCE_TYPE_SUBJECT
      );
      competenciesTechnology.value = response.competencies.items.filter(
        (el) => el.type === COMPETENCE_TYPE_TECHNOLOGY
      );
      competenciesSkill.value = response.competencies.items.filter(
        (el) => el.type === COMPETENCE_TYPE_SKILL
      );
    } catch (error) {
      console.error('error', error);
    }
  };

  const onFinish = async () => {
    try {
      await api.briefcase.saveCompetencies({
        briefcaseId: route.params.id,
        competenciesSubject: competenciesSubject.value,
        competenciesTechnology: competenciesTechnology.value,
        competenciesSkill: competenciesSkill.value,
      });

      await getCompetencies();
      emit('saved', true);
    } catch (error) {
      errors.handleApiErrors(error);
      emit('saved', false);
    }
  };
  defineExpose({ onFinish });

  const updateCompetenciesSubject = (competenceList) => {
    competenciesSubject.value = [...competenceList];
  };
  const updateCompetenciesSkill = (competenceList) => {
    competenciesSkill.value = [...competenceList];
  };
  const updateCompetenciesTechnology = (competenceList) => {
    competenciesTechnology.value = [...competenceList];
  };
</script>

<style lang="scss" scoped>
  @use '@/components/form/main-form.scss';

  .competencies_form_item {
    margin-bottom: 14px;
  }
</style>
